import { DesktopOutlined } from '@ant-design/icons';
import { Radio } from 'antd';
import { message } from '@/components/Message';
import React from 'react';
import PosPopover from '@/components/PosPopover';
import PosButton from '@/components/PosButton';
import { setConsumerDisplayImage } from '@/models/consumerDisplay';
import { playSound } from '@/utils/sound';
import { Custom_Display_Type_ENUM } from '@/utils/uiHelper';

export default () => {
  return (
    <PosPopover
      getPopupContainer={() => document.body}
      destroyOnHidden
      trigger={'click'}
      title={
        <>
          <DesktopOutlined /> 副屏显示
        </>
      }
      content={
        <>
          <Radio.Group
            onChange={e => {
              playSound('click');
              const value = e.target.value;
              setConsumerDisplayImage(value);
              message.success('设置成功');
            }}>
            <Radio.Button value={Custom_Display_Type_ENUM.PRICE}>价目表</Radio.Button>
            <Radio.Button value={Custom_Display_Type_ENUM.CARD}>企微名片</Radio.Button>
          </Radio.Group>
        </>
      }>
      <PosButton icon={<DesktopOutlined />} type="primary" />
    </PosPopover>
  );
};
